module.exports = __webpack_public_path__ + "img/prematch.69a6d4a4.png";